import React from "react";
import Sidebar from "../components/sidebar/Sidebar";

const Layout = ({ children, noSidebar }) => {
  return (
    <div className="flex h-screen">
      {!noSidebar && <Sidebar />}
      <main className="flex-1 overflow-y-auto p-4 bg-gray-50">
        {children}
      </main>
    </div>
  );
};

export default Layout;
